import axios, {Axios, AxiosError, AxiosInstance, AxiosRequestConfig} from "axios";
import {apiUrl, domainUrl} from "./apiUrl";
import {ServerExceptionModel} from "../model/core/ServerExceptionModel";
import {getLocaleFromLocal, setLocalIpInHeaders} from "../core/localization/localizationHelper";
import {isBlank} from "../helpers/stringHelper";

const qs = require("qs");

export interface MinoAxios extends AxiosInstance {
    onError: { [key: string]: (error: any) => void }

}


const getToken = () => {
    const ls = localStorage.getItem('token');
    if (ls !== null) {
        return ls as string;
    }
    return '' as string;
};
const getRefreshToken = () => {
    const ls = localStorage.getItem('refreshToken');
    if (ls !== null) {
        return ls as string;
    }
    return '' as string;
};
// const setLocalIpInHeaders = (config: any) => {
//     let localIp = getLocalIpSync();
//     if (localIp === "undefined") {
//         setLocalIpAsync();
//     }
//     config.headers!["localIp"] = localIp;
// };

const timeoutValue = 90000;
const api = axios.create({
    baseURL: domainUrl,
    timeout: 600000,
    withCredentials: true,
    paramsSerializer: function (params) {
        return qs.stringify(params, {
            encode: false,
        })
    },

}) as MinoAxios;


const fixConfig = (axios: Axios, config: AxiosRequestConfig) => {
    const token = getToken();
    if (!!token) {
        config.headers!["Authorization"] = `Bearer ${token}`;
    }
    if ((axios.defaults as any).agent === (config as any).agent) {
        delete (config as any).agent;
    }
    if (axios.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axios.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
    if(config.timeout === undefined ||config.timeout < timeoutValue){
        config.timeout = timeoutValue // 70 saniye;
    }

}

api.onError = {};


api.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (!!token) {
            config.headers!["Authorization"] = `Bearer ${token}`;
        }
        config.withCredentials = true;

        config.headers!["Accept-Language"] = getLocaleFromLocal();
        setLocalIpInHeaders(config);
        if (config.method?.toLowerCase() === "post" || config.method?.toLowerCase() === "put") {
            config.headers!["Content-Type"] = "application/json";
        }

        if(config.timeout === undefined ||config.timeout < timeoutValue){
            config.timeout = timeoutValue // 70 saniye;
        }
        return config;
    }, function (error) {
        return Promise.reject(error)
    }
);

api.interceptors.response.use(
    (response) => {
        if (response.data.exception) {
            throw response.data.exception
        }

        return response
    },
    (error: AxiosError) => {
        const {config, response} = error;
        if (!config) {
            return Promise.reject(error);
        }
        if (response?.status === 401) {
            const errorMessage = (response?.data as any)?.exception as ServerExceptionModel
            if (errorMessage?.simpleCode?.startsWith?.("AUTHENTICATION")) {
                const numberError = Number(errorMessage.simpleCode.replace("AUTHENTICATION",""));
                if (errorMessage.simpleCode === "AUTHENTICATION4") {
                    localStorage.removeItem("token");
                    config.transformRequest = [(data) => data];
                    return new Promise((resolve) => setTimeout(() => {
                        const tempApi = axios.create({
                            baseURL: domainUrl,
                            timeout: 600000,
                            withCredentials: true,
                            paramsSerializer: function (params) {
                                return qs.stringify(params, {
                                    encode: false,
                                })
                            }
                        });
                        const refreshToken = getRefreshToken();
                        if(isBlank(refreshToken)){
                            localStorage.removeItem("refreshToken");
                            window.location.reload();
                        }
                        try {
                            tempApi.get(apiUrl.auth.userLogin + "refreshToken/" + getRefreshToken()).then(data => {
                                if (data.status === 200) {
                                    localStorage.setItem("refreshToken", data.data?.data?.refreshToken ?? "")
                                    localStorage.setItem("token", data.data?.data?.accessToken ?? "")
                                    fixConfig(api, config);
                                    resolve(axios(config))
                                }else{
                                    localStorage.removeItem("refreshToken");
                                }
                            }).catch(
                                (e)=>{
                                    window.location.reload();
                                    console.log(e);
                                }
                            )
                        }
                        catch (e){
                            window.location.reload();
                            console.log(e);
                        }

                    }, 3));


                }else if(1<=numberError && numberError <=9){

                    if(response.request.responseURL.includes("his-services")){
                        localStorage.removeItem("token");
                        window.location.reload();
                    }else{
                    }

                }
                else {

                }

            }
        }

        const events = Object.keys(api.onError);
        events.forEach(value => {
            if (api.onError[value] !== undefined) {
                api.onError[value](error);
            }
        })
        return Promise.reject(error.response)
    }
);

export default api;